import React from 'react'
import ContractManagement from './ContractMangment'

const UnknownManagement = () => {
  return (
    <>
      <ContractManagement unknown_employee={true} />
    </>
  )
}

export default UnknownManagement
